module.exports = __webpack_public_path__ + "static/img/02-zhihuizhongtaiyun.bcfd6aa3.png";